import TemplateView from '../../../../../../js/TemplateView'
import {ICalLightboxType} from '../../../constants'
import messageResource from '../../../../../../js/messageResource'

export default class EditFeedLightBoxHeader extends TemplateView {
    constructor() {
        super()
        this.state = {
            type: null,
        }

        this.onStatePropertyChanged('type', type => {
            this.$lightBoxTitle.text(messageResource.getMessage(type === ICalLightboxType.CREATE
                                                                ? 'icalendar.page.lightbox.create.title'
                                                                : 'icalendar.page.lightbox.edit.title'))
        })
    }

    getCloseButtonEl() {
        return this.find('.closeButton')
    }

    templateHtml() {
        return `<div class='dialog-header iCalLightBoxHeader'>
                    <div class='closeButton'/>
                    <div class='lightBoxTitle'/>
                </div>`
    }

    afterRender() {
        this.$lightBoxTitle = this.find('.lightBoxTitle')

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/EditFeedLightBoxHeader.js